export default __webpack_public_path__ + "static/media/image-board-study-pattern-n-w@2x.c6c9d724.png";